var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"pa-2",class:_vm.customClass,attrs:{"disabled":_vm.disabled,"max-width":_vm.maxWidth},on:{"click":_vm.action}},[_vm._v(_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }